import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {PrimeIcons} from 'primeng/api';

interface Mime {
  mime: string;
  pattern: (number | undefined)[];
}

const imageMimes: Mime[] = [
  {
    mime: 'application/pdf',
    pattern: [0x25, 0x50, 0x44, 0x46]
  }
];

@Component({
    selector: 'app-orderconfirmation',
    templateUrl: './orderconfirmation.component.html',
    styleUrls: ['./orderconfirmation.component.scss'],
    standalone: false
})
export class OrderconfirmationComponent implements OnInit {

  @Input() orderConfirmationData: any = [];
  @Output() orderConfirmationChange: EventEmitter<any> = new EventEmitter<[]>();
  
  states: any;
  events:any;
  selectedState:any;
  email:string = 'johndoe@gmail.com'
  orderDetails:any = {id:'#23481636',service:'CAT Edit',date:'28/04/2023'}
  selectFile: any;
  fileName: string = 'Browse';
  pdfSource: any;
  uploadFile!: File;
  isDocUploaded: boolean = false;

  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  @ViewChild('uploadSuccessModal') uploadSuccessModal!: ElementRef;
  @ViewChild('uploadDocSuccessModalPopup') uploadDocSuccessModalPopup!: ElementRef;
  
  constructor(private router:Router) { 
 
  this.events = [
    {status: 'Ordered', date: '15/10/2020', icon: PrimeIcons.SHOPPING_CART, color: '#9C27B0', image: 'game-controller.jpg'},
    {status: 'Processing', date: '15/10/2023', icon: PrimeIcons.COG, color: '#673AB7'},
    {status: 'Delivered', date: '16/10/2023', icon: PrimeIcons.CHECK, color: '#607D8B'}
];
  }

  ngOnInit(): void {
    this.selectFile =
    [
      { label: 'Select', value: 'Select' }
    ];
  }
  gotoDashboard(){
    this.router.navigate(['doqfy/dashboard']);
  }

  sendconfermationData() {
    this.orderConfirmationChange.emit(this.orderConfirmationData);
  }

  onFileChange(event: any) {

    let files = event.target.files;
    this.fileName = files[0].name;
    const fileSize = files[0].size / 1024 / 1024;
    if (fileSize > 10) {
      alert('File should be less than 10MB in size');

      return;
    }
    let splitName = files[0].name.split('.');
    if (splitName[splitName.length - 1] !== 'pdf') {
      alert('Not a valid PDF file. Please upload another one');

      return;
    } else if (splitName.length > 2) {
      alert('File name should have only single extension');

      return;
    }

    let $img: any = document.querySelector('#upload_file');

    if (typeof (FileReader) !== 'undefined') {
      let reader = new FileReader();

      reader.onload = (e: any) => {
        this.pdfSource = e.target.result;
      };

      reader.readAsArrayBuffer($img.files[0]);
    }

    this.validateImageMimeType(files[0], valid => {
      if (!valid) {
        alert('Not a valid PDF file. Please upload another one');

      } else {
        this.uploadFile = files[0];
      }
    });
  }

  isMime(bytes: Uint8Array, mime: Mime): boolean {
    return mime.pattern.every((p, i) => !p || bytes[i] === p);
  }

  validateImageMimeType(file: File, callback: (b: boolean) => void) {
    const numBytesNeeded = Math.max(...imageMimes.map(m => m.pattern.length));
    const blob = file.slice(0, numBytesNeeded);

    const fileReader = new FileReader();

    fileReader.onloadend = e => {
      if (!e || !fileReader.result) return;

      const bytes = new Uint8Array(fileReader.result as ArrayBuffer);

      const valid = imageMimes.some(mime => this.isMime(bytes, mime));

      callback(valid);
    };

    fileReader.readAsArrayBuffer(blob);
  }

  gotoTemplatePage() {
    this.onSendProductDetails();
  }

  onSendProductDetails() {
    //this.uploadDocumentsData = this.productDetails.value;
   // this.productDetailsChange.emit(this.uploadDocumentsData);
  }

  cancelUpload() {
    this.closeUploadPopupBtn.nativeElement.click();
  }

  uploadSelFile() {
    this.isDocUploaded = true;
    this.closeUploadPopupBtn.nativeElement.click();
    setTimeout(() => { 
      this.uploadDocSuccessModalPopup.nativeElement.click();
      this.isDocUploaded = false;
    }, 1500); 
  }

}
